// Mirror of ALLOWED_ORIGINS in api/stack/api_stack.py — keep in sync.
// Flattened to a union below: the front-end build is not stage-aware.
const ALLOWED_ORIGINS_BY_STAGE: Record<string, string[]> = {
  dev: [
    "http://localhost:3000",
    "http://localhost:3002",
    "http://localhost:3003",
    "http://localhost:3005",
    "https://dev.allointelligence.allobrain.com",
    "https://dev.login.allobrain.com",
    "https://dev.qm.allobrain.com",
    "https://dev.allobot.allobrain.com",
    "https://dev-allobot.allobrain.com",
    "https://dev.apps.allobrain.com",
    "https://dev.platform.allobrain.com",
    "https://next.platform.allobrain.com",
    "https://allocall-desk.allobrain.com",
    "https://dev-webapp.allobrain.com",
  ],
  prod: [
    "https://login.allobrain.com",
    "https://qm.allobrain.com",
    "https://prod.allointelligence.allobrain.com",
    "https://allointelligence.allobrain.com",
    "https://allobot.allobrain.com",
    "https://apps.allobrain.com",
    "https://platform.allobrain.com",
    "https://allocall-desk.allobrain.com",
    "https://webapp.allobrain.com",
  ],
};

export const ALLOWED_REDIRECT_ORIGINS: ReadonlySet<string> = new Set(
  Object.values(ALLOWED_ORIGINS_BY_STAGE).flat()
);
